import React from 'react';
import LinkButton from '../../input/LinkButton';

export const SectionSummaryTestId = 'SectionSummary-summary';
export const SectionSummaryContentTestId = 'Content-SectionSummary-summary';

export type SectionSummaryGroupPosition = 'First' | 'Last' | 'Between';

type SectionSummaryBaseProps = {
  title: string;
  content: React.ReactNode | string;
  toolTipKey: string;
  groupPosition?: SectionSummaryGroupPosition;
  className?: string;
  toolTipText?: string;
  disableActionButton?: boolean;
  linkButtonDataTestId?: string;
};

type SectionWithActionButtonProps = {
  displayActionButton: true;
  disableActionButton?: boolean;
  toolTipText?: string;
  actionButtonText: string;
  onActionButtonClicked?: () => void;
};

type SectionWithoutActionButtonProps = {
  displayActionButton?: never;
  actionButtonText?: never;
  onActionButtonClicked?: never;
};

export type SectionSummaryProps = SectionSummaryBaseProps &
  (SectionWithActionButtonProps | SectionWithoutActionButtonProps);

const SectionSummary: React.FC<SectionSummaryProps> = ({
  title,
  content,
  groupPosition,
  displayActionButton,
  disableActionButton,
  actionButtonText,
  toolTipText,
  toolTipKey,
  linkButtonDataTestId,
  onActionButtonClicked,
  className = '',
}: SectionSummaryProps) => {
  const getBorderClasses = (): string => {
    switch (groupPosition) {
      case 'First':
        return 'rounded-t-md';
      case 'Last':
        return 'border-t-0 rounded-b-md';
      case 'Between':
        return 'border-t-0';
      default:
        return 'rounded-md';
    }
  };
  return (
    <div className={`px-2 ${className}`} data-testid={SectionSummaryTestId}>
      <div
        className={`flex flex-row p-2 border checkout-panel-border ${getBorderClasses()} text-sm leading-5`}
      >
        <span className="flex-none w-2/12">{title}</span>
        <span
          className={`text-black-300 ${
            displayActionButton ? 'w-8/12' : 'w-10/12'
          }`}
          data-testid={SectionSummaryContentTestId}
        >
          {content}
        </span>
        {displayActionButton === true &&
          onActionButtonClicked &&
          actionButtonText && (
            <span className="w-2/12 place-content-end text-right">
              <LinkButton
                onClick={(): void => onActionButtonClicked?.()}
                disableActionButton={disableActionButton}
                toolTipText={disableActionButton ? toolTipText : undefined}
                toolTipKey={toolTipKey}
                dataTestId={linkButtonDataTestId}
              >
                {actionButtonText}
              </LinkButton>
            </span>
          )}
      </div>
    </div>
  );
};

export default SectionSummary;
